/**
 * The local name fold (1.K-1 deliverables 2 and 12), mirroring `normName` of
 * `@codex/doc-model` without importing it (that would pull the editor schema into this pure
 * package): NFKD, combining marks removed, typographic quotes and dashes folded, lower case,
 * `ß` to `ss`, white space collapsed and trimmed.
 */
export function foldName(s) {
    return s
        .normalize('NFKD')
        .replace(/\p{M}/gu, '')
        .replace(/[‘’]/g, "'")
        .replace(/[“”]/g, '"')
        .replace(/[–—]/g, '-')
        .toLowerCase()
        .replace(/ß/g, 'ss')
        .replace(/\s+/gu, ' ')
        .trim();
}
/** The words the parser reserves (deliverable 2, `ambiguous_name`); a name that folds to one warns. */
export const RESERVED_WORDS = new Set([
    'now',
    'session',
    'undated',
    'early',
    'mid',
    'late',
    'week',
    'of',
    'century',
    'until',
    'since',
    'to',
    'at',
    'after',
    'before',
    'during',
    'same',
    'time',
    'as',
    'circa',
    'about',
    'around',
    'c',
]);
//# sourceMappingURL=fold.js.map